import React from 'react'
import { Col, Row } from 'reactstrap';

// For Masters
function mapUnits(unitLevels) {
  if (!unitLevels || unitLevels.length === 0) {
    return null;
  }
  if (unitLevels.length > 1) {
    return unitLevels.slice(1).map((unit, ind) => {
      const prevUnit = unitLevels[ind]?.unit;
      return (
        <h6 key={ind}>
          {"1 " + prevUnit + " = " + unit.value + " " + unit.unit}
        </h6>
      );
    });
  } else {
    return unitLevels.map((unit, ind) => {
      const prevUnit = unitLevels[ind - 1]?.unit;
      return (
        // <h6 key={ind}>
        //   {"1 " + (prevUnit || unit.unit) + " = " + (ind > 0 ? unit.value + " " + unit.unit : "NA")}
        // </h6>
         <h6 key={ind}>
          {unit.unit}
        </h6>
      );
    });
  }
}

//For PO
function showQuantity(quantity) {
  if (!quantity || quantity.length === 0) {
    return null;
  }

  return quantity.map((unitObj, index) => (
    <span key={index}>

      <Row>
        <Col lg={12} md={12}>
          {(unitObj.value) + " " + (unitObj.unit)}
        </Col>
      </Row>
    </span>
  ))

}

//For Displaying in columns 
function formatUnits(quantity) {
  if (!quantity || quantity.length === 0) {
    return " ";
  }

  return quantity.map((unitObj, index) => (
    <span key={index}>
      {(unitObj.value) + " " + (unitObj.unit)} &nbsp;
    </span>
  ))

}

function showAvailable(available,unitLevels) {
  if (!available || available.length === 0) {
    return unitLevels?.map((unitObj, index) => (
      <span key={index}>
        {0 + " " + (unitObj.unit)} &nbsp;
      </span>
    ));
  }else{
    return available.map((unitObj, index) => (
      <span key={index}>
        {(unitObj.value) + " " + (unitObj.unit)} &nbsp;
      </span>
    ))
  }
}

// for Masters
function exportFromula(unitLevels) {
  // if (!unitLevels || unitLevels.length === 0) {
  //   return null;
  // }
  // return unitLevels.map((unit, ind) => {
  //   const prevUnit = unitLevels[ind - 1]?.unit;
  //   return "1 " + (prevUnit || unit.unit) + " = " + (ind > 0 ? unit.value + " " + unit.unit : "NA");
  // }).join(', ');
  if (unitLevels.length > 1) {
    return unitLevels.slice(1).map((unit, ind) => {
      const prevUnit = unitLevels[ind]?.unit;
      return `1 ${prevUnit} = ${unit.value} ${unit.unit}`;
    }).join(', ');
  } else {
    return unitLevels.map(unit => unit.unit).join(', ');
  }
}


function ExportAvailableInCSVForReports(unitLevels) {
  if (!unitLevels || unitLevels.length === 0) {
    return '';
  }

  const startIndex = unitLevels.findIndex(unit => unit.value !== 0);

  if (startIndex=== -1) {
    const lastUnit = unitLevels[unitLevels.length - 1];
    return `${lastUnit.value} ${lastUnit.unit}`;
  }

  return unitLevels.slice(startIndex)
    .map(unit => `${unit.value} ${unit.unit}`)
    .join(', ');
}

function formatUnitsForReport(quantity) {
  if (!quantity || quantity.length === 0) {
    return " ";
  }
  const startIndex = quantity.findIndex(unitObj => unitObj.value !== 0);
  
  // If all values are 0, show the last index
  if (startIndex === -1) {
    const lastIndex = quantity.length - 1;
    return (
      <span key={lastIndex}>
        {quantity[lastIndex].value + " " + quantity[lastIndex].unit} &nbsp;
      </span>
    );
  }

  return quantity.slice(startIndex).map((unitObj, index) => (
    <span key={startIndex + index}>
      {unitObj.value + " " + unitObj.unit} &nbsp;
    </span>
  ));
}


// for Exporting CSV 
function ExportAvailableInCSVForReports2(unitLevels) {
  if (!unitLevels || unitLevels.length === 0) {
    return null;
  }
  const availableString = unitLevels.map(unit => {
    const key = unit.unit;
    const value = unit.value;
    return `${value} ${key}`;
  }).join(' ');

  return `${availableString}`;

}

function DebitCase(have, want, map) {
  function passToParent(have, map, want, i) {
    have[i - 1]["value"] -= 1;
    have[i]["value"] += map[i]["value"];
    return have;
  }
  let haveUpdated;
  have
    .slice()
    .reverse()
    .forEach((obj, index) => {
      const l = have.length;
      const i = l - index - 1;

      if (have[i]["value"] < want[i]["value"]) {
        if (i > 0) {
          haveUpdated = passToParent(have, map, want, i);
        }
      }
    });

  haveUpdated
    ? haveUpdated.forEach((obj, index) => {
      obj["value"] -= want[index]["value"];
    })
    : have.forEach((obj, index) => {
      obj["value"] -= want[index]["value"];
    });

  return haveUpdated ? haveUpdated : have;
}
function sortQuantityByUnitLevels(unit_levels, quantity) {
  return quantity.sort((a, b) => {
      // Find the index of each unit in unit_levels
      const indexA = unit_levels.findIndex(level => level.unit === a.unit);
      const indexB = unit_levels.findIndex(level => level.unit === b.unit);

      // Compare indices to determine order
      return indexA - indexB;
  });
}
function GetUpdatedDelivered(quantity, unitLevels) {
  let available = [];
  const deliveredQuantity = sortQuantityByUnitLevels(unitLevels, quantity);

  if (
    deliveredQuantity.length === 0 ||
    deliveredQuantity.length < unitLevels.length
  ) {
    available = unitLevels.map((unit,index) => ({
      unit: unit.unit,
      value:
        deliveredQuantity.find((delivery) => delivery.unit === unit.unit)
          ?.value || 0,
      index: index,
      isChecked: (deliveredQuantity.find((delivery) => delivery.unit === unit.unit)?.value || 0) > 0    }));
  } else {
    available = deliveredQuantity.map((delivery,index) => ({
      unit: delivery.unit,
      value: delivery.value,
      index: index,
      isChecked: delivery.value > 0
    }));
  }

  for (let i = unitLevels.length - 1; i > 0; i--) {
    const currentUnit = unitLevels[i];
    const previousUnit = unitLevels[i - 1];
    while (available[i].value >= currentUnit.value) {
      available[i].value -= currentUnit.value;
      available[i - 1].value++;
    }
  }
  let updatedValues = [];
  let startPushing = false;
  // available.forEach((unit) => {
  //   if (unit.value >= 0) {
  //     updatedValues.push({ unit: unit.unit, value: unit.value ,index: unit.index, 
  //       isChecked: unit.value > 0});
  //   }
  // });
  for (let i = 0; i < available.length; i++) {
    // if (available[i].value > 0 || startPushing) {
      startPushing = true;
      updatedValues.push({
        unit: available[i].unit,
        value: Number(available[i].value),
        index: available[i].index,
        isChecked: available[i].value > 0
      });
    // }
  }
  // const sortedQuantity = sortQuantityByUnitLevels(unitLevels, updatedValues);
//  return sortedQuantity
  return updatedValues;
}

function GetUpdatedValue(available, items, type, unitlevels) {
  if (available.length === 0 || available.length < unitlevels.length) {
    available = unitlevels.map((unit) => ({
      unit: unit.unit,
      value: available.find((avail) => avail.unit === unit.unit)?.value || 0,
    }));
  }

  if (type === "Credit") {
    items.forEach((item) => {
      const unitIndex = available.findIndex((unit) => unit.unit === item.unit);
      if (unitIndex !== -1) {
        available[unitIndex].value += item.value;
      }
    });
  } else if (type === "Debit") {
    DebitCase(available, items, unitlevels);
  }

  for (let i = unitlevels.length - 1; i > 0; i--) {
    const currentUnit = unitlevels[i];
    const previousUnit = unitlevels[i - 1];
    while (available[i].value >= currentUnit.value) {
      available[i].value -= currentUnit.value;
      available[i - 1].value++;
    }
  }

  let updatedValues = [];
  available.forEach((unit) => {
    if (unit.value >= 0) {
      updatedValues.push({ unit: unit.unit, value: unit.value });
    }
  });
  return updatedValues;
}
function MapObjectUnits(obj) {
  let result = "";
  const keys = Object.keys(obj);
  const startIndex = keys.findIndex(key => obj[key] !== 0);
  if (startIndex === -1) return;
  for (let i = startIndex; i < keys.length; i++) {
    const key = keys[i];
    const value = obj[key];
    result += `${value} ${key} `;
  }
  return result.trim()
  // console.log(result.trim());
}
function MapAllObjectUnits(obj) {
  let result = "";
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = obj[key];
    result += `${value}`;
  }
  return result.trim()
  // console.log(result.trim());
}

function MapTotalForArrangement(obj) {
  let result = "";
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = obj[key];
    result += `${value} ${key}`;
  }
  return result.trim()
}

function MapUnitForArrangement(obj) {
  let result = "";
  const keys = Object.keys(obj);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const value = obj[key];
    result += `${key}`;
  }
  return result.trim()
  // console.log(result.trim());
}

function convertToLowestUnit(unitLevels=[], inventory=[]) {
  const conversionFactors = {};
  let conversionFactor = 1;
  for (let i = unitLevels.length - 1; i >= 0; i--) {
    const level = unitLevels[i];
    conversionFactors[level.unit] = conversionFactor;
    conversionFactor *= level.value;
  }
  let totalInLowestUnit = 0;
  inventory.forEach(item => {
    const itemValueInLowestUnit = item.value * conversionFactors[item.unit];
    totalInLowestUnit += itemValueInLowestUnit;
  });
  return totalInLowestUnit;
}

function  validateDeliveryQuantities (itemsForDelivery) {
  for (const item of itemsForDelivery) {
    const order_quantity = convertToLowestUnit(item.unit_levels, item.quantity);
    const available = convertToLowestUnit(item.unit_levels, item.central_available);

    if (order_quantity > available) {
      return `Quantity for item ${item.name} exceeds available stock.`;
    }
  }
  return null;
};

export {
  mapUnits,
  MapUnitForArrangement,
  MapTotalForArrangement,
  exportFromula,
  ExportAvailableInCSVForReports2,
  showQuantity,
  formatUnits,
  showAvailable,
  GetUpdatedValue,
  GetUpdatedDelivered,
  validateDeliveryQuantities,
  MapObjectUnits,
  formatUnitsForReport,
  ExportAvailableInCSVForReports,
  MapAllObjectUnits,
  convertToLowestUnit,
}

//  GetUpdatedValue( GetUpdatedDelivered(have,map), GetUpdatedDelivered(want,map), "Debit", map)